import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  ticketDetailsDescriptionSummary: {
    wordBreak: 'break-word',
    '& li': {
      margin: '0.563rem 0'
    },
    '& p': {
      margin: '0.984rem 0'
    },
    '& ul': {
      margin: '0.984rem 0'
    },
    '& table': {
      border: `1px solid ${theme.vars.palette.border.main}`,
      borderCollapse: 'collapse'
    },
    '& th': {
      backgroundColor: theme.vars.palette.background.elevation0,
      border: `1px solid ${theme.vars.palette.border.main}`,
      padding: '0.563rem',
      textAlign: 'left'
    },
    '& td': {
      border: `1px solid ${theme.vars.palette.border.main}`,
      padding: '0.563rem'
    }
  }
}));

export default useStyles;
